import { BookOutlined } from '@ant-design/icons-vue';
import QuizzesManagement from '@/views/quizzes/QuizzesManagement.vue';
import QuizzesEdit from '@/views/quizzes/QuizzesEdit.vue';
import QuizzesView from '@/views/quizzes/QuizzesView.vue';
import QuizzesSetAnswers from '@/views/quizzes/QuizzesSetAnswers.vue';
import QuizzesAttemptView from '@/views/quizzes/QuizzesAttemptView.vue';

export const quizzesFolderRoute = {
    path: 'quizzes',
    name: 'Quizzes',
    redirect: '/quizzes-management',
    meta: {
        title: '測驗管理',
        icon: BookOutlined
    },
    children: []
};

export const quizzesChildrenRoutes = [
    {
        path: '/quizzes-management',
        component: QuizzesManagement,
        name: 'QuizzesManagement',
        meta: {
            title: '測驗設置'
        }
    },
    {
        path: '/quizzes-reviews',
        component: () => import('@/views/quizzes/QuizzesReviews.vue'),
        name: 'QuizzesReviews',
        meta: {
            title: '測驗審核'
        }
    },
    {
        path: '/quizzes-attempts',
        component: () => import('@/views/quizzes/QuizzesAttempts.vue'),
        name: 'QuizzesAttempts',
        meta: {
            title: '作答紀錄'
        }
    },
    {
        path: '/quizzes-create',
        component: QuizzesEdit,
        name: 'QuizzesCreate',
        meta: {
            title: '新增測驗',
            hidden: true
        }
    },
    {
        path: '/quizzes-view/:id',
        component: QuizzesView,
        name: 'QuizzesView',
        meta: {
            title: '查看測驗',
            hidden: true
        }
    },
    {
        path: '/quizzes-edit/:id',
        component: QuizzesEdit,
        name: 'QuizzesEdit',
        meta: {
            title: '編輯測驗',
            hidden: true
        }
    },
    {
        path: '/quizzes-set-answers/:id',
        component: QuizzesSetAnswers,
        name: 'QuizzesSetAnswers',
        meta: {
            title: '設置答案',
            hidden: true
        }
    },
    {
        path: '/quizzes-attempt-view/:id',
        component: QuizzesAttemptView,
        name: 'QuizzesAttemptView',
        meta: {
            title: '查看作答詳情',
            hidden: true
        }
    }
];
